import { createFileRoute } from '@tanstack/react-router';
import { PayoutsPage } from '../features/payouts/PayoutsPage';
import { validatePayoutsSearch } from '../features/payouts/search';

export const Route = createFileRoute('/payouts')({
  validateSearch: validatePayoutsSearch,
  component: PayoutsPage,
});
